// ARM scroll reveal — single global observer, safe to load multiple times.
// Failsafe: 1.5s after page load, force any remaining .arm-reveal elements
// to .arm-in. This prevents the page from staying invisible if the
// IntersectionObserver fails to fire (no-JS env, error elsewhere on page,
// elements in nested layouts, etc.).
(function () {
  if (window._armRevealReady) return;
  window._armRevealReady = true;

  var SEL = '.arm-reveal, .arm-reveal-left, .arm-reveal-right, .arm-reveal-scale, .arm-reveal-img';

  function revealAll() {
    var pending = document.querySelectorAll(SEL);
    pending.forEach(function (el) { el.classList.add('arm-in'); });
  }

  function init() {
    var els = document.querySelectorAll(SEL);
    if (!els.length) return;

    // Failsafe: if IntersectionObserver isn't available, reveal everything now.
    if (typeof IntersectionObserver === 'undefined') {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('arm-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });

    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('arm-in');
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Belt-and-suspenders: after 1.5s, force-reveal anything still hidden.
  // Catches cases where the observer never fires (e.g. layout shifts past
  // viewport, JS error blocked init, scripts deferred too late).
  setTimeout(revealAll, 1500);

  // Also reveal everything once the window has fully loaded, in case images
  // shifted layout and arm-reveal elements ended up off-screen.
  if (window.addEventListener) {
    window.addEventListener('load', function () { setTimeout(revealAll, 200); });
  }
})();
